export default "__VITE_ASSET__nVfUhWwr__"